import BurggerButton from 'components/home/navbar/buttons/burgger-button';
import CultureShow from 'core/culture-show';
import fontStyles from 'styles/Fonts.module.scss';
import Hide from 'core/hide';
import Image from 'core/image';
import MyAcountButton from 'components/home/navbar/buttons/my-acount-button';
import phoneIcon from 'static/img/icons/phone-icon-magenta.svg';
import styles from 'styles/Header.module.scss';
import { useScroll } from 'hooks';
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { WhiteButton } from 'core/buttons/buttons';

const KeypadNewHome = () => {
    const t = useTranslations('header.keypad');
    const [display, setDisplay] = useState('');

    useScroll((scroll) => {
        setDisplay(scroll > 100 ? 'none' : '');
    }, []);

    const handleClick = () => {
        const elm = document.getElementById('faq');
        if (elm?.scrollIntoView) {
            elm.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <div className={styles.HeaderNavbarRawRow}>
            <div className={styles.keypad}>
                {display !== 'none' && <BurggerButton />}
                <div
                    style={{
                        marginLeft: '2%',
                        marginRight: '2%',
                        display
                    }}
                >
                    <Hide md>
                        <WhiteButton
                            label={t('help-button.text')}
                            onClick={handleClick}
                            compact
                        />
                    </Hide>
                </div>
                <CultureShow cultures={['es-ar']}>
                    <div style={{ marginLeft: '2%', display }}>
                        <Hide md>
                            <WhiteButton
                                label={t('my-policy.text')}
                                href={t('my-policy.link')}
                                compact
                            />
                        </Hide>
                    </div>
                </CultureShow>
                <CultureShow cultures={['es-ar']}>
                    <div style={{ marginLeft: '20%', display }}>
                        <Hide md>
                            <MyAcountButton buttonType="new-home" />
                        </Hide>
                    </div>
                </CultureShow>
                <CultureShow cultures={['es-ar', 'es-mx', 'pt-br']}>
                    <Hide lg>
                        <a
                            className={styles.phone_container_color}
                            href={t('phone.link')}
                            style={{ display }}
                        >
                            <Image
                                src={phoneIcon}
                                width={25}
                                height={20}
                                alt={t('phone.text')}
                            />
                            <span className={fontStyles.text_header4}>
                                {t('phone.text')}
                            </span>
                            <p className={fontStyles.text_small}>
                                {t('phone.description')}
                            </p>
                        </a>
                    </Hide>
                </CultureShow>
            </div>
        </div>
    );
};

export default KeypadNewHome;
